<era-mobilefolio-ui [mobileFolio]="mobileFolio()"
                    [reservation]="reservation()"
                    (save)="save($event)"></era-mobilefolio-ui>